/* exported addEventOnEligibilityButtonClick showIfEligibilityPrice*/
async function updateProperties(lineItemKey, properties, quantity) {
	try {
		const body = JSON.stringify({
			id: lineItemKey,
    		properties: Object.keys(properties).length === 0 ? { '_unionPrice': null } : properties,
    		quantity: quantity,
		});
		const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: body,
		});
		return response.json();
	} catch (error) {
		alert(error.message);
	}
}

async function addEventOnEligibilityButtonClick(eligibilityButtons, companyId = null) {
	eligibilityButtons.forEach((eligibilityButton) => {
		// Check if the event listener is already attached
		if (!eligibilityButton.hasAttribute('data-listener-attached')) {
			eligibilityButton.addEventListener('click', async function () {
				const lineItemKey = eligibilityButton.getAttribute('data-line-item-key');
				const lineItemProperties = eligibilityButton.getAttribute('data-line-item-properties');
				const jsonProperties = JSON.parse(lineItemProperties);				

				const hasUnionPrice = jsonProperties.some(
					([key, value]) => key === '_unionPrice'
				);

				if (!hasUnionPrice) {
					const confirmation = await showEligibilityConfirmation();
					if (!confirmation) {
						return; 
					}
				}

				const eligibilityPrice = getEligibilityPrice(eligibilityButton, companyId);
				const formattedProperties = formatProperties(jsonProperties, eligibilityPrice);
				const lineItemQuantity = eligibilityButton.getAttribute('data-line-item-quantity');

				await updateProperties(lineItemKey, formattedProperties, lineItemQuantity);
				location.reload();
			});

			// Mark that the listener has been attached
			eligibilityButton.setAttribute('data-listener-attached', 'true');
		}
	});
}

// Changing the Properties format from array to object
function formatProperties(propertiesArray, eligibilityPrice = null) {
	const propertiesObject = {};
	if (eligibilityPrice) {
		propertiesObject['_unionPrice'] = String(eligibilityPrice);
	}
	for (const [key, value] of propertiesArray) {
		if (key !== '_unionPrice') {
			propertiesObject[key] = String(value);
		}
	}
	return propertiesObject;
}
function getEligibilityPrice(EligibilityButton, companyId = null) {
	try {
		if (!companyId) {
			throw new Error('Committee number does not exist');
		}
		const dataProductString = EligibilityButton.getAttribute('data-product');
		const dataProduct = JSON.parse(dataProductString);
		return dataProduct[companyId].eligibility_price;
	} catch {
		return null;
	}
}

function showIfEligibilityPrice(
	addEligibilityButtons,
	finalEligibilityAmount,
	companyId = null
) {
	for (let i = 0; i < addEligibilityButtons.length; i++) {
		const eligibilityPrice = getEligibilityPrice(addEligibilityButtons[i], companyId);
		if (!eligibilityPrice) {
			return;
		}
		const lineItemQuantity = addEligibilityButtons[i].getAttribute('data-line-item-quantity');
		if (lineItemQuantity <= finalEligibilityAmount) {
			addEligibilityButtons[i].removeAttribute('hidden');
		}
	}
}

function showEligibilityConfirmation() {
	return new Promise((resolve) => {
		const eligibilityModal = document.getElementById('modal-eligibility-confirm');
		const okButton = document.getElementById('modal-eligibility-confirm-ok');
		const cancelButton = document.getElementById('modal-eligibility-confirm-cancel');

		eligibilityModal.classList.remove('hide-eligibility-confirm-modal');

		okButton.onclick = () => {
			resolve(true);
		};

		cancelButton.onclick = () => {
			resolve(false);
			eligibilityModal.classList.add('hide-eligibility-confirm-modal');
		};
	});
}
